import React, { useEffect, useState } from "react";
import Modal from "react-modal";
// import moment from "moment";
import moment from "moment-timezone";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";

import Select from "react-select";
import { DatePicker, DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import { gapDays } from "../../../../constants/constants";

import { useSelector } from "react-redux";
import {
  editPateintAssessmentsLogic,
  createPateintAssessmentsLogic,
} from "../../../../store/features/patient/assessmentsSlice";
import { notify } from "../../../../util/helpers";
import ViewAssessmentModal from "./ViewAssessmentModal";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "50%",
  },
};

const PatientAssessmentModal = (props) => {
  Modal.setAppElement("#root");
  const {
    modalIsOpen,
    setModalOpen,
    assessment,
    assessmentName,
    patientId,
    modalName,
    data,
    setPatientAssessments,
    setCaregiverAssessments,
  } = props;

  function toggleModal() {
    setModalOpen(!modalIsOpen);
  }
  const { assessmentTypes } = useSelector((state) => state?.assessment);
  const { singlePatientData } = useSelector((state) => state?.patient);
  const [assessmentSelected, setAssessmentSelected] = useState(null);
  const [assesmentNames, setAssesmentNames] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [qnAModal, showQnAModal] = useState(false);
  const [selectedGapDays, setSelectedGapDays] = useState(null);
  const { beforeToday } = DateRangePicker;
  useEffect(() => {
    const tempAssesmentNames = assessmentTypes?.map((element) => {
      if (assessment?.assessment_name === element.name) {
        setAssessmentSelected({ label: element.name, value: element.id });
      }
      return { label: element.name, value: element.id };
    });

    try {
      setSelectedGapDays(assessment?.gap_days?.toString());
    } catch (e) {
      console.log(e);
    }

    setAssesmentNames(tempAssesmentNames);
    setStartDate(
      assessment?.start_date ? new Date(assessment?.start_date) : new Date()
    );
    if (modalName === "Edit Assessment") {
      setEndDate(
        assessment?.end_date ? new Date(assessment?.end_date) : new Date()
      );
    }
  }, []);
  function handleAssessmentSelected(e) {
    setAssessmentSelected(e);
  }
  const handleGapDaysSelected = (e) => {
    setSelectedGapDays(e.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedGapDays === null || selectedGapDays === undefined) return;
    if (modalName === "Edit Assessment") {
      const assessmentId = assessment?.assessment;
      let scheduleFor = patientId;
      if (assessmentId === 26 || assessmentId === 11) {
        scheduleFor = singlePatientData?.caregiver_id;
      }
      let payload = {
        gap_days: selectedGapDays,
        end_date: moment(endDate).add(1, "d").format("YYYY-MM-DD"),
        patient: scheduleFor,
        assessment: assessment?.assessment,
      };

      editPateintAssessmentsLogic(assessment?.id, payload)
        .then((res) => {
          const temp = [...data];
          const targetIndex = data?.findIndex(
            (ele) => ele?.id === assessment?.id
          );
          if (targetIndex !== -1) {
            temp[targetIndex] = res?.data;
          }
          if (assessmentId === 26 || assessmentId === 11) {
            setCaregiverAssessments(temp);
          } else {
            setPatientAssessments(temp);
          }
          setModalOpen(false);
        })
        .catch((err) => {
          notify("Something went wrong", "error");
        });
    } else {
      const assessmentId = assessmentSelected?.value;
      let scheduleFor = patientId;
      if (assessmentId === 26 || assessmentId === 11) {
        scheduleFor = singlePatientData?.caregiver_id;
      }
      let payload = {
        start_date: moment(startDate).format("YYYY-MM-DD"),
        gap_days: selectedGapDays,
        end_date: moment(endDate).add(1, "d").format("YYYY-MM-DD"),
        patient: scheduleFor,
        assessment: assessmentId,
      };
      createPateintAssessmentsLogic(payload)
        .then((res) => {
          const temp = [...data, res?.data];
          if (assessmentId === 26 || assessmentId === 11) {
            setCaregiverAssessments(temp);
          } else {
            setPatientAssessments(temp);
          }
          notify("Assessment scheduled successfully!");
          setModalOpen(false);
        })
        .catch((err) => {
          console.log("Error in scheduling a new assessment", err);
          notify("Something went wrong", "error");
        });
    }
  };
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={toggleModal}
        style={customStyles}
        contentLabel=""
        ariaHideApp={false}
      >
        <div
          className="container-fluid"
          style={{ margin: "0px", padding: "2.5%", paddingBottom: "5%" }}
        >
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={toggleModal}
          >
            <CloseIcon />
          </button>
          <ViewAssessmentModal
            modalIsOpen={qnAModal}
            setModalOpen={showQnAModal}
            assessmentName={assessmentSelected}
          />
          <CardLayout className="p-3">
            <div className="w-100 py-2 d-flex">
              <h3 className="primary-text-blue">{modalName}</h3>
            </div>
            <form onSubmit={handleSubmit} className="container-fluid p-1">
              <div className="form-group py-3">
                <label>Choose Assessment Type </label>
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      padding: "0px",
                      backgroundColor: "transparent",
                      width: "50rem",
                      border: "0px",
                      outline: "0px",
                      color: "#94A3B8 !important",
                      borderBottom: "1px solid #94A3B8 !important",
                    }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Choose Assessment Type"
                  classNamePrefix="select"
                  name="assessment-type"
                  options={assesmentNames}
                  onChange={handleAssessmentSelected}
                  value={assessmentSelected}
                  isDisabled={modalName === "Edit Assessment"}
                />
              </div>
              {assessmentSelected && (
                <div className="form-group px-2">
                  <a
                    href="javascript:void(0);"
                    rel="noreferrer noopener"
                    onClick={() => {
                      showQnAModal(true);
                    }}
                  >
                    View Assessment Questions
                  </a>
                </div>
              )}

              <div className="container-fluid px-0 py-3 row w-100">
                <div
                  className="col-sm-12 col-md-5 col-lg-5 px-3"
                  style={{ width: "50%" }}
                >
                  <label>Start Date </label>
                  <DatePicker
                    placeholder="MM/DD/YYYY"
                    appearance="subtle"
                    name="start_date"
                    id="start_date"
                    oneTap
                    value={startDate}
                    onChange={setStartDate}
                    disabled={modalName === "Edit Assessment"}
                    caretAs={CalendarIcon}
                    shouldDisableDate={beforeToday()}
                    format="MM/dd/yyyy"
                    className="custom-datepicker"
                    aria-autocomplete=""
                  />
                </div>
                <div
                  className="col-sm-12 col-md-5 col-lg-5 px-3"
                  style={{ width: "50%" }}
                >
                  <label>End Date </label>
                  <DatePicker
                    placeholder="MM/DD/YYYY"
                    appearance="subtle"
                    name="end_date"
                    id="end_date"
                    oneTap
                    value={endDate}
                    onChange={setEndDate}
                    caretAs={CalendarIcon}
                    shouldDisableDate={beforeToday()}
                    format="MM/dd/yyyy"
                    className="custom-datepicker"
                    autoComplete={false}
                  />
                </div>
              </div>
              <div className="form-group py-3">
                <label>How Often </label>
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      padding: "0px",
                      backgroundColor: "transparent",
                      width: "50rem",
                      border: "0px",
                      outline: "0px",
                      color: "#94A3B8 !important",
                      borderBottom: "1px solid #94A3B8 !important",
                    }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Days"
                  classNamePrefix="select"
                  name="gapDays"
                  options={gapDays}
                  onChange={handleGapDaysSelected}
                  value={gapDays.find((e) => e.value === selectedGapDays)}
                />
              </div>
              <div
                className="d-flex justify-content-end mt-5"
                style={{ gap: "2%" }}
              >
                <button className="btn alternative-btn" onClick={toggleModal}>
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={
                    selectedGapDays === null || selectedGapDays === undefined
                  }
                  className="primary-btn"
                >
                  Submit
                </button>
              </div>
            </form>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};
export default PatientAssessmentModal;
